// FontAwesome
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
// Solid Icons
import {
  faAddressCard,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowTurnDown,
  faArrowUp,
  faArrowUpFromBracket,
  faArrowsRotate,
  faBars,
  faBell,
  faBuilding,
  faCalendar,
  faCalendarCheck,
  faCalendarPlus,
  faCalendarXmark,
  faCamera,
  faCircleStop,
  faChartBar,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCartShopping,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleHalfStroke,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCircleXmark,
  faClipboard,
  faClock,
  faClockRotateLeft,
  faCog,
  faCoins,
  faComment,
  faComments,
  faCopy,
  faCrop,
  faDatabase,
  faDiamondTurnRight,
  faDownLeftAndUpRightToCenter,
  faDownload,
  faEnvelope,
  faExpand,
  faEye,
  faEyeSlash,
  faFile,
  faFileContract,
  faFileExcel,
  faFileInvoice,
  faFileLines,
  faFilePdf,
  faFilePen,
  faFileWord,
  faFilter,
  faFloppyDisk,
  faFolder,
  faFolderOpen,
  faGripVertical,
  faHandshake,
  faHandshakeSlash,
  faLink,
  faLinkSlash,
  faListCheck,
  faLocationCrosshairs,
  faLocationDot,
  faMap,
  faLock,
  faLockOpen,
  faMagnifyingGlass,
  faMessage,
  faMinus,
  faMobileScreen,
  faMoneyBillWave,
  faMugHot,
  faObjectGroup,
  faObjectUngroup,
  faPalette,
  faPaperPlane,
  faPaperclip,
  faParagraph,
  faPaste,
  faPenToSquare,
  faPerson,
  faPersonDigging,
  faPhone,
  faPlus,
  faPrint,
  faQuestion,
  faReceipt,
  faRightFromBracket,
  faRightToBracket,
  faRotate,
  faRotateLeft,
  faRotateRight,
  faScissors,
  faScrewdriverWrench,
  faSliders,
  faTableColumns,
  faTag,
  faTimeline,
  faTrashCan,
  faTrashRestore,
  faTriangleExclamation,
  faTruck,
  faTruckRampBox,
  faUpRightFromSquare,
  faUser,
  faUserLock,
  faUserPlus,
  faUserXmark,
  faWandMagicSparkles,
  faWrench,
  faXmark,
  faFileImage,
  faGasPump,
  faClone as faCloneSolid,
  faBug
} from "@fortawesome/free-solid-svg-icons"

// Regular Icons
import { faClone as faCloneRegular } from "@fortawesome/free-regular-svg-icons"

// Brand Icons
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons"
// Add to Library
import { library } from "@fortawesome/fontawesome-svg-core"
library.add(
  faAddressCard,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowTurnDown,
  faArrowUp,
  faArrowUpFromBracket,
  faArrowsRotate,
  faBars,
  faBell,
  faBuilding,
  faCalendar,
  faCalendarCheck,
  faCalendarPlus,
  faCalendarXmark,
  faCamera,
  faCircleStop,
  faCaretDown,
  faCaretLeft,
  faChartBar,
  faCaretRight,
  faCartShopping,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleHalfStroke,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCircleXmark,
  faClipboard,
  faClock,
  faClockRotateLeft,
  faCoins,
  faCog,
  faComment,
  faComments,
  faCopy,
  faCrop,
  faDatabase,
  faDiamondTurnRight,
  faDownload,
  faDownLeftAndUpRightToCenter,
  faEnvelope,
  faExpand,
  faEye,
  faEyeSlash,
  faFile,
  faFileContract,
  faFileExcel,
  faFileInvoice,
  faFileLines,
  faFileWord,
  faFilePdf,
  faFilePen,
  faFilter,
  faFloppyDisk,
  faFolder,
  faFolderOpen,
  faGripVertical,
  faHandshake,
  faHandshakeSlash,
  faLink,
  faLinkSlash,
  faListCheck,
  faLocationCrosshairs,
  faLocationDot,
  faMap,
  faLock,
  faLockOpen,
  faMagnifyingGlass,
  faMessage,
  faMinus,
  faMobileScreen,
  faMoneyBillWave,
  faMugHot,
  faObjectGroup,
  faObjectUngroup,
  faPalette,
  faPaperPlane,
  faPaperclip,
  faParagraph,
  faPaste,
  faPenToSquare,
  faPerson,
  faPersonDigging,
  faPhone,
  faPlus,
  faPrint,
  faQuestion,
  faReceipt,
  faRightFromBracket,
  faRightToBracket,
  faRotate,
  faRotateLeft,
  faRotateRight,
  faScrewdriverWrench,
  faSliders,
  faScissors,
  faTableColumns,
  faTag,
  faTimeline,
  faTrashCan,
  faTrashRestore,
  faTriangleExclamation,
  faTruck,
  faTruckRampBox,
  faUpRightFromSquare,
  faUser,
  faUserLock,
  faUserPlus,
  faUserXmark,
  faWhatsapp,
  faWrench,
  faXmark,
  faWandMagicSparkles,
  faFileImage,
  faGasPump,
  faCloneSolid,
  faCloneRegular,
  faBug
)
export default FontAwesomeIcon
